import Grid from "@material-ui/core/Grid";
import { Paper } from "@mui/material";
import React, { useEffect, useState } from "react";
import LazyLoad from "react-lazyload";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getAllSupplierInfo } from "../../services/assortiment/actions";
import "../catalogus/Catalogus.scss";
import "../infoScreens/infoScreen.scss";

export function AllSuppliersGrid(props) {
  const [farmerInfo, setFarmerInfo] = useState("");

  useEffect(() => {
    getAllSupplierInfo(props.loginSuccesful, props.identifyInfo, setFarmerInfo);
  }, []);

  return (
    <Grid
      container
      justifyContent="space-evenly"
      alignItems="flex-start"
      spacing={3}
    >
      {farmerInfo !== ""
        ? farmerInfo?.map((item, i) => (
            <LazyLoad placeholder="loading">
              <Grid item xs={12}>
                <Item key={i} item={item} />
              </Grid>
            </LazyLoad>
          ))
        : null}
    </Grid>
  );
}

function Item(props) {
  return (
    <Paper>
      <div style={{ width: "300px", margin: 10 }}>
        {props.item.photo ? (
          <Link
            style={{ textDecoration: "none" }}
            to={{
              pathname: "/supplierinfo",
              state: { from: props.item.id },
            }}
          >
            <div style={{ textAlign: "center" }}>
              <div style={{ position: "relative" }}>
                <img // TODO: images moeten allemaal dezelfde afmetingen hebben
                  src={props.item.photo}
                  style={{
                    maxWidth: "100%",
                    maxHeight: "200px",
                    resize: "contain",
                  }}
                />
                <div className="cardContentAllSuppliers">{props.item.name}</div>
              </div>
            </div>
          </Link>
        ) : null}
      </div>
    </Paper>
  );
}

function mapStateToProps(state) {
  return {
    loginSuccesful: state.login.data.loginSuccesful,
    identifyInfo: state.identify.identifyInfo,
  };
}

export default connect(mapStateToProps, {})(AllSuppliersGrid);
